export default __webpack_public_path__ + "static/media/section-about-img-5.311e6289.png";